import { jwtDecode } from 'jwt-decode';

const getToken = () => {
    const token = localStorage.getItem('token');
    return token;
};

const getUserIdFromToken = (token) => {
    console.log('Token type:', typeof token); // Should be 'string'
    console.log('Token value:', token); // Should be the token string

    try {
        if (typeof token !== 'string') {
            throw new Error('Token must be a string');
        }
        const decoded = jwtDecode(token);
        console.log('Decoded token:', decoded); // Debugging line
        return decoded.userId; // Adjust based on your token payload
    } catch (error) {
        console.error('Error decoding token:', error);
        return null;
    }
};

const logoutUser = () => {
    localStorage.removeItem('token');
};

export { getToken, getUserIdFromToken, logoutUser };
